<template>
  <div class="flex py-1 text-left md:items-center">
    <i
      class="flex h-5 min-w-5 max-w-5 items-center justify-center"
      :class="warningClass">
      <InfoIcon class="h-auto w-full" />
    </i>
    <div class="gc-font-notes px-2" :class="props.textClass">
      {{ props.text }}
    </div>
  </div>
</template>

<script setup>
import InfoIcon from '@icons/info.svg';
const props = defineProps({
  text: String,
  warningClass: {
    type: String,
    default: 'text-warning',
  },
  textClass: {
    type: String,
    default: '',
  },
});
</script>
